import React, { useContext, useEffect } from "react";
import "./Styles/Portal.css";
//import background from "../Images/Patterns/AM2_Pattern_A.png";
import background from "../Images/Patterns/SAFRIPOL_Pattern_A.png";
import { Menu } from "./Menu";
import { Frame } from "./Frame";
import { Header } from "./Header";
import { EditableMenu } from "./EditableMenu";
import { MenuContext } from "./Contexts/MenuContext";
import { FrameContext } from "./Contexts/FrameContext";
import { fetchFrameTokens } from "./Functions/Fetch";
import { useMsal } from "@azure/msal-react";

export const Portal = () => {
  const { instance, accounts } = useMsal();
  const [menuContext] = useContext(MenuContext);
  const [frameContext, setFrameContext] = useContext(FrameContext);

  useEffect(() => {
    fetchFrameTokensAsync(
      instance,
      accounts,
      frameContext,
      setFrameContext,
      menuContext.useAnonymous
    );
  }, [menuContext.useAnonymous]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className="Portal"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <Header />
      <Menu />
      {menuContext?.isEditing ?? false ? (
        <EditableMenu />
      ) : frameContext.isFetchingFrameTokens ? (
        <></>
      ) : (
        <Frame name={frameContext.frameName} src={frameContext.frameSrc} />
      )}
    </div>
  );
};

const fetchFrameTokensAsync = async (
  instance,
  accounts,
  frameContext,
  setFrameContext,
  useAnonymous
) => {
  try {
    useAnonymous || (await fetchFrameTokens(instance, accounts));
    setFrameContext({ ...frameContext, isFetchingFrameTokens: false });
  } catch (e) {
    console.log(e);
    setFrameContext({ ...frameContext, isFetchingFrameTokens: false });
  }
};
